import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AdminRoutingModule } from './admin-routing.module';
import { ScheduleComponent } from './schedule/schedule.component';
import { AdminComponent } from './admin.component';
import { BudgetsComponent } from './budgets/budgets.component';
import { ClientsComponent } from './clients/clients.component';
import { ProvidersComponent } from './providers/providers.component';
import { JwPaginationComponent } from 'src/app/jw-pagination/jw-pagination.component';
import { FilterPipe } from 'src/app/pipes/client-filter.pipe';
import { ProviderFilterPipe } from 'src/app/pipes/provider-filter.pipe';
import { BudgetFilterPipe } from 'src/app/pipes/budget-filter.pipe';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { AuthenticationService } from 'src/app/auth/authentication.service';
import { AngularFireAuthGuard } from '@angular/fire/auth-guard';
import { LoginComponent } from './login/login.component';
import { ScrollToDirective } from 'src/app/directives/scroll-to.directive';

@NgModule({
  declarations: [
  ScheduleComponent,
  AdminComponent,
  BudgetsComponent,
  ClientsComponent,
  ProvidersComponent,
  JwPaginationComponent,
  FilterPipe,
  ProviderFilterPipe,
  BudgetFilterPipe,
  LoginComponent,
  ScrollToDirective
],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
  ],
  providers: [
    AuthenticationService,
    AngularFireAuthGuard
  ]
})
export class AdminModule { }
